import React from "react"
import {Stack, Typography} from "@mui/material";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOSvg from "../../fundamentals/CCOSvg";
import {
    SosTextfragmentFragment
} from "../../../../packages/graphql-layer/src/queries/fragments/__generated__/SOSTextfragment.fragment";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import {stripTreeText} from "../../../utility/componentUtil";
import {Box} from "@mui/system";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import useWindowSize from "../../../utility/useWindowSize";

export interface Props {
    sosTextFragment: SosTextfragmentFragment
    className?: string
    insideCarousel?: boolean
}

function C027Quote(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const {greaterThanWindowMedium, greaterThanWindowLarge, lowerThanWindowSmall} = useWindowSize();
    // Indirektion aus SOSHDL-448: Wenn bei Textfragment der Detailtext gesetzt ist, wird der verwendet.
    // Nur, wenn der leer ist, dann wird auf den Teaser-Text zurückgegriffen.
    let teaserText;
    if (props.sosTextFragment.detailText) {
        teaserText = stripTreeText(props.sosTextFragment.detailText.textAsTree);
    } else if (props.sosTextFragment.teaserText) {
        teaserText = stripTreeText(props.sosTextFragment.teaserText.textAsTree);
    }
    return (<CCOComponentWrapper className={props.className ?? 'carousel-content'} noTopMargin={true}>
            <CCOContainer id={props.sosTextFragment.id} background={"primary.main"} width={'large'}
                          sx={{
                              height: {xl: '624px', lg: '372px', md: '267px', xs: undefined},
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              aspectRatio: {xs: '1/1', md: undefined},
                          }}
            >
                <Stack height={'100%!important'} display={'flex'} flexDirection={'column'}
                       spacing={{xl: 3, lg: 3, md: 2, sm: 2, xs: 2}} padding={3}>
                    <Stack spacing={{xl: 3, lg: 2, md: 2, sm: 2, xs: 2}}>
                        <CCOSvg src={'/quote.svg'} size={38}/>
                        <Typography color={'primary.contrastText'}
                                    variant={lowerThanWindowSmall ? 'h4' : greaterThanWindowMedium && !greaterThanWindowLarge ? 'h4' : 'h3'}
                                    align={'center'}>
                            {teaserText}
                        </Typography>
                    </Stack>
                    <Typography color={'primary.contrastText'} align={'center'} variant={'body2'} {...metaDataProperty(isPreview, 'properties.teaserTitle', props.sosTextFragment.id)}>
                        {props.sosTextFragment.teaserTitle!}
                    </Typography>
                </Stack>
            </CCOContainer>
        {props.insideCarousel ? <></> : <Box height={greaterThanWindowMedium ? 50 : 30}/>}
        </CCOComponentWrapper>
    )
}

export default C027Quote;